import { render, staticRenderFns } from "./vFormImageDixCell.vue?vue&type=template&id=6b30464c&scoped=true&"
import script from "./vFormImageDixCell.vue?vue&type=script&lang=js&"
export * from "./vFormImageDixCell.vue?vue&type=script&lang=js&"
import style0 from "./vFormImageDixCell.vue?vue&type=style&index=0&id=6b30464c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b30464c",
  null
  
)

export default component.exports